import { CONFIG } from '@/core/config';
import { useStudyModeStore } from '@/store';

import { FetchClientOptions, FetchInstance } from './fetch.model';
import {
  createDeleteRequest,
  createGetRequest,
  createPatchRequest,
  createPostRequest,
  createPutRequest,
  createSSERequest,
} from './util';

function getAddendumModeHeaders(): Record<string, string> {
  return useStudyModeStore.getState().isAddendumMode ? { 'X-Addendum-Mode': 'true' } : {};
}

function createFetchClient(
  baseURL: string,
  { getExtraHeaders }: FetchClientOptions = {},
): FetchInstance {
  const del = createDeleteRequest(baseURL, getExtraHeaders);
  const sse = createSSERequest(baseURL, getExtraHeaders);
  const get = createGetRequest(baseURL, getExtraHeaders);
  const patch = createPatchRequest(baseURL, getExtraHeaders);
  const post = createPostRequest(baseURL, getExtraHeaders);
  const put = createPutRequest(baseURL, getExtraHeaders);

  return { delete: del, get, patch, post, put, sse };
}

const APPS = createFetchClient(CONFIG.APPS_SERVER);
const FCT = createFetchClient(CONFIG.FCT_SERVER, { getExtraHeaders: getAddendumModeHeaders });
const HI = createFetchClient(CONFIG.HI_SERVER);
const PII = createFetchClient(CONFIG.PII_SERVER);

export const fetchClient = { APPS, FCT, HI, PII };
